<template>
  <div>
    <b-input-group>
      <b-input-group-prepend v-if="isTeacher" class="search-button">
        <b-button @click="searchCourse">
          <font-awesome-icon icon="search"></font-awesome-icon>
        </b-button>
      </b-input-group-prepend>
      <b-nav-form class="search" @submit.prevent="searchCourse">
        <v-autocomplete
          :items="items"
          v-model="item"
          :get-label="getLabel"
          :wait="100"
          :min-len="1"
          :component-item="template"
          @update-items="searchKeys"
          @item-clicked="searchCourse"
          @item-selected="searchCourse"
          :placeholder="placeholderText"
          :auto-select-one-item="false"
          id="search"
          v-on:keyup.enter="searchKeys"
          class="search-bar-input"
        >
        </v-autocomplete>
      </b-nav-form>
      <b-input-group-append v-if="!isTeacher" class="search-button">
        <b-button @click="searchCourse">
          <font-awesome-icon icon="search"></font-awesome-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
import { customerApi } from "../../services/customerApi";
import { videoApi } from "../../services/videoApi";
import searchListTemplate from "./SearchListTemplate";
export default {
  name: "Search-bar",
  props: {
    isTeacher: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      item: "",
      template: searchListTemplate,
      items: [],
      placeholderText: "What do you want to learn.."
    };
  },
  methods: {
    getLabel(item) {
      if (this.isTeacher) {
        return item.teacher_name;
      } else {
        return item.search_name;
      }
    },
    searchKeys(text) {
      this.items = [];
      if (this.isTeacher) {
        customerApi
          .searchTeacher(text)
          .then(res => {
            this.items = res.data;
          })
          .catch(() => {
            this.items = [
              {
                noResult: true,
                teacher_id: false,
                no_result: "Sorry! No result Found.. "
              }
            ];
          });
      } else {
        videoApi
          .searchKeys(text)
          .then(res => {
            this.items = res.data;
          })
          .catch(() => {
            this.items = [
              {
                noResult: true,
                course_id: false,
                no_result: "Sorry! No result Found.. "
              }
            ];
          });
      }
    },
    searchCourse() {
      if (this.item.course_id || this.item.teacher_id) {
        if (this.isTeacher) {
          this.$router.push({
            path: "/teacher",
            query: {
              teacherId: this.item.teacher_id
            }
          });
        } else {
          this.$router.push({
            path: "/course_description",
            query: { courseId: this.item.course_id }
          });
        }
      }
    }
  },
  mounted() {
    if (this.isTeacher) {
      this.placeholderText = "Search Teacher by Name...";
    } else {
      this.placeholderText = "What do you want to learn...";
    }
      document.querySelector('.header-search-bar .v-autocomplete-input').addEventListener("focus", function () {
          document.querySelector('.header-search-bar').classList.add('focus');
      });
    document.querySelector('.header-search-bar .v-autocomplete-input').addEventListener("blur", function () {
          document.querySelector('.header-search-bar').classList.remove('focus');
      });

  }
};
</script>

<style scoped></style>
